<template>
  <div id="app"
       v-loading.body="globalLoading"
       element-loading-spinner="el-icon-loading">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'app',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    ...mapState({
      globalLoading: state => state.app.globalLoading
    })
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/App.vue